import { CaretDownIcon } from '@radix-ui/react-icons'
import { AxisIcon } from '@/components/icons/AxisIcon'
import { ResetIcon } from '@/components/icons/ResetIcon'
import { DrumIcon } from '@/components/icons/DrumIcon'
import { DrumOutlineIcon } from '@/components/icons/DrumOutlineIcon'
import { DrumTransparentIcon } from '@/components/icons/DrumTransparentIcon'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@/components/ui/dropdown-menu'
import { ControlButton } from './ControlButton'
import { ExplosionsToolbar } from './ExplosionsButton/ExplosionsButton'
import { CrossSectionButton } from './CrossSectionButton/CrossSectionButton'

import { useShallow } from 'zustand/react/shallow'
import { useCADQuery } from '@/services/queries/cads'
import { AppearanceButton } from './AppearanceButton'
import { useCADPageStore, SectionState, ExplosionsState } from '@/state/cad'

export const Controls = () => {
  const toggleAxis = useCADPageStore((state) => state.toggleAxis)
  const explosions = useCADPageStore((state) => state.explosions)
  const disableSectioning = useCADPageStore((state) => state.disableSectioning)
  const setCadPageState = useCADPageStore(useShallow((state) => state.setState))
  const setWandSelected = useCADPageStore((state) => state.setWandSelected)
  const renderMode = useCADPageStore((state) => state.renderMode)
  const parts = useCADPageStore(useShallow((state) => state.transparentParts))
  const colorMap = useCADPageStore((state) => state.colorMap)

  const { isLoading, data: cadData } = useCADQuery()
  const gltf = cadData.gltf
  const assemblyTree = cadData.rawAssemblyTree

  if (isLoading || !gltf || !assemblyTree) return null

  return (
    <>
      <div>
        <ControlButton
          title="Show Axis"
          icon={<AxisIcon className="w-4 h-4" />}
          onClick={() => {
            toggleAxis()
          }}
        />
      </div>
      <AppearanceButton />
      <div>
        <ControlButton
          title="Reset All"
          icon={<ResetIcon className="w-4 h-4" />}
          onClick={() => {
            gltf.showExplosionLines(explosions, assemblyTree, false)
            gltf.resetExplosions(explosions)
            gltf.unhighlightParts(colorMap)
            gltf.clearDragLines()
            gltf.resetColors()
            gltf.resetTransparency(parts)
            gltf.resetClippingPlanes()

            assemblyTree.nodes.map((node) =>
              gltf.setVisibility(node.instance, true),
            )

            setCadPageState({
              target: useCADPageStore.getState().sceneCenter?.toArray(),
              isDragging: false,
              selectedParts: [],
              loadedExplosion: '',
              explosions: {},
              hiddenParts: [],
              colorMap: {},
              transparentParts: [],
              highlightedPartUUID: null,
              isEditModeActive: false,
              clippingPlanes: [],
              sectionState: SectionState.RESET,
              explosionsState: ExplosionsState.DISABLED,
              operationStep: null,
            })
          }}
        />
      </div>
      <ExplosionsToolbar />
      <CrossSectionButton />
      <div>
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger>
            <ControlButton
              asChild
              icon={
                <div className="flex flex-row items-center">
                  <DrumIcon className="w-4 h-4" />
                  <CaretDownIcon />
                </div>
              }
              onClick={(e) => {
                e.stopPropagation()
                setWandSelected(null)
                setCadPageState({
                  selectedParts: [],
                  explosionsState: ExplosionsState.DISABLED,
                })
                disableSectioning()
              }}
              title="Display"
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="flex flex-row">
            <DropdownMenuItem>
              <ControlButton
                isActive={renderMode === 'full-color'}
                icon={<DrumTransparentIcon className="w-4 h-4" />}
                title="Color"
                onClick={() => {
                  setCadPageState({ renderMode: 'full-color' })
                }}
              />
            </DropdownMenuItem>
            <DropdownMenuItem>
              <ControlButton
                isActive={renderMode === 'outline'}
                icon={<DrumOutlineIcon className="w-4 h-4" />}
                title="Outline"
                onClick={() => {
                  setCadPageState({ renderMode: 'outline' })
                }}
              />
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  )
}
